import helpers from "./DataserviceHelpers";
import Backend from "../Backend"

class ExecutiveData {

    static searchExecutiveByName = function (name) {
        const fields = ["D_ID", "D_Diszi", "D_Bemerkungen", "D_Name"]
        const fieldlist = helpers.generateFieldlist(fields)
        return Backend.getData(`/api/TAB_DISZI/search?D_Name=${name}&${fieldlist}`);
    }

    static deleteExecutive =function(contraction) {
        return Backend.deleteData(`/api/TAB_DISZI/${contraction}`)
    }

    static getEmployees = async function (executive) {
        const fields = ["M_Diszi"]
        const fieldlist = helpers.generateFieldlist(fields)
        let data = Backend.getData(`${executive._links["Mitarbeiter dieses Diszis"].href}?${fieldlist}`);
        return await data;
    }

    static getExecutiveByContraction = function (contraction) {
        const fields = ["D_ID", "D_Name"]
        const fieldlist = helpers.generateFieldlist(fields)
        return Backend.getData(`/api/TAB_DISZI/${contraction}?${fieldlist}`);
    }
}

export default ExecutiveData;
